module.exports = __webpack_public_path__ + "media/staff/default_female-1ae5c363.jpg";